<template>
    <div id="main-layout" class="main-layout flex flex-col min-h-screen justify-center items-center pt-6 px-8 overflow-x-hidden">
        <div class="mb-20" style="width: 100%; max-width: 1440px;">
            <menu-superior></menu-superior>
        </div>
        <div style="width: 100%; min-height: 100vh; max-width: 1440px;">
            <router-view/>
        </div>
        <main-footer style="max-width: 1440px;"></main-footer>
        <img src="../assets/layout/bg_2.png" style="position: absolute; top: -200px; left: -250px; width: 1000px; z-index: -1;" />
    </div>
</template>

<script>
import MainFooter from '../components/MainFooter.vue'
import MenuSuperior from '../components/MenuSuperior.vue'

export default {
    components: { MenuSuperior, MainFooter },
    mounted() {
        const geometrics = []
        const colorPallete = ['#E8A8C8','#F0A32E','#7FC699','#E86C44','#8CD0E8']

        for(let g = 0; g < 20; g++) {
            let nGeo = document.createElement('div')
            nGeo.className = 'bg-el'
            nGeo.style.left = `${Math.floor(Math.random() * 100)}vw`;
            nGeo.style.top = `${Math.floor(Math.random() * document.body.clientHeight)}px`;
            nGeo.style.borderBottomColor = colorPallete[Math.floor(Math.random() * colorPallete.length)]
            // document.body.append(nGeo)
            document.getElementById('main-layout').append(nGeo)
            geometrics.push(nGeo)
        }

        geometrics.forEach((g, i) => {
            let to = {
                x: Math.random() * (i % 2 === 0 ? -11 : 11),
                y: Math.random() * 12
            };

            g.animate(
                [
                    { transform: "translate(0, 0) skew(10deg, 10deg)" },
                    { transform: `translate(${to.x}rem, ${to.y}rem) rotate(180deg)` },
                ],
                {
                    duration: (Math.random() + 1) * 2000,
                    direction: "alternate",
                    fill: "both",
                    iterations: Infinity,
                    easing: "ease-in-out"
                }
            );
        })
    }
}
</script>

<style>
.bg-el {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -2;
    width: 0;
    height: 0;
    opacity: .5;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 30px solid black;
}

body {
    overflow-x: hidden;
}
</style>